<script setup lang="ts">
import type { Category } from '~/types';
// Define the prop to get dynCategories array
const props = defineProps<{
  dynCats?: { title: string; slug: string; color: string }[];
}>();

// Compute the filter condition dynamically based on the dynCats prop
const filterCondition = computed(() => {
  return props.dynCats && props.dynCats.length > 0
    ? { filter: { title: { _in: props.dynCats.map((cat) => cat.title) } } }
    : {};
});

// Always restrict categories to those that apply to the blog or both
const appliesFilter = { category_applies_to: { _in: ['blog', 'both'] } };

//console.log('filterCondition', filterCondition.value);
// Fetch the categories from Directus with filtering
// Merge title filter (when present) with the appliesFilter under the `filter` key
const queryOptions = {
  fields: ['id', 'slug', 'color', 'title', 'category_applies_to'],
  filter: {
    ...(filterCondition.value?.filter ?? {}),
    ...appliesFilter,
  },
};

const { data: categories } = await useAsyncData('categories', () => {
  return useDirectusProxy<Category[]>({ operation: 'readItems', collection: 'categories', params: queryOptions });
});
</script>
<template>
  <div class="mt-4 space-y-2">
    <div v-for="category in categories" :key="category.id">
      <NuxtLink :href="`/posts/categories/${category.slug}`" class="dark:text-gray-200 hover:opacity-80">
        <Category :color="category.color ?? undefined" size="lg">
          {{ category.title }}
        </Category>
      </NuxtLink>
    </div>
  </div>
</template>
